export const fileUploadInitialState = {
  inProgress: false,
  file: ''
}

export type FileUploadState = typeof fileUploadInitialState
